<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations?.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations?.lbl_loading}}</span>
</div>


<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">

            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>

            <button *ngIf="globalUserDataForm.get('selectedQuantity')?.value > 0" pButton pRipple icon="pi pi-save"
                class="p-m-2 z-5" (click)="createByInitialButton()" pTooltip="{{translations.lbl_update}}"
                class="p-button-success p-m-2 z-5"
                [disabled]="this.dataParent.status == 'R' || globalUserDataForm.get('selectedDate').value == null || blocked"
                ngif>
            </button>

            <button *ngIf="globalUserDataForm.get('selectedLocmatctlm')?.value?.id?.sequence != null 
            && (globalUserDataForm.get('selectedLocmatctlm').value)?.status === 'N' " pButton pRipple
                icon="pi pi-trash" class="p-button-danger p-m-2 z-5" (click)="deleteRecord()" [disabled]="blocked">
            </button>

            <button *ngIf="globalUserDataForm.get('selectedLocmatctlm')?.value?.id?.sequence != null && globalUserDataForm.get('selectedLocmatctlm')?.value?.id?.year != null &&
            this.dataParent?.levelId != null" pButton pRipple icon="pi pi-check" class="p-button-success p-m-2 z-5"
                [ngStyle]="{'background-color': '#960018', 'border-color': '#960018', 'color': 'white'}"
                pTooltip="{{translations.lbl_approve}}" (click)="displayConfirmationView()"
                [disabled]="this.dataParent.status == 'R'  || blocked">
            </button>


            <button pButton pRipple icon="pi pi-eye" class="p-button-success p-m-2 z-5" (click)="toggleView()"
                [label]="globalUserDataForm.get('selectedDocumentsViewLabel').value"
                *ngIf="globalUserDataForm.get('selectedQuantity')?.value > 0">
            </button>

        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <!-- CORDINATION FORM -->
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-fluid" [formGroup]="globalUserDataForm" *ngIf="translations != null">

                    <!-- GUIDE FORM -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{ translations.lbl_guide }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedGuide').value != null; else noSelectionGuide">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedGuide').value || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionGuide>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- COORDINATION INPUT FORM -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{ translations.lbl_coordination }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedCoordination').value != null; else noSelectionCoordination">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedCoordination').value || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionCoordination>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- TYPE INPUT FORM -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{ translations.lbl_type }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedComponentType').value != null; else noSelectionType">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedComponentType').value || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionType>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_type
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- LANGUAGE INPUT FORM
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{ translations.lbl_language }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedLanguage').value?.value != null; else noSelectionLanguage">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedLanguage').value?.value || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionLanguage>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_language
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div> -->

                    <!-- PERIOD INPUT FORM -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{ translations.lbl_period }}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedPeriod').value?.descrip != null; else noSelectionPeriod">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedPeriod').value?.descrip || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionPeriod>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_period
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- LIST INPUT FORM -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_price_list}} {{translations.lbl_current}}</span>
                        <ng-container
                            *ngIf="globalUserDataForm.get('selectedList').value != null; else noSelectionList">
                            <span class="p-text-bold">
                                {{ globalUserDataForm.get('selectedList').value || " " }}</span>
                        </ng-container>

                        <ng-template #noSelectionList>
                            <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_price_list+ '
                                ' + translations.lbl_current
                                + ' ' +
                                translations.lbl_select}}</span>
                        </ng-template>
                    </div>

                    <!-- AMOUNT -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_amount}} {{translations.lbl_material}}</span>
                        <span class="p-text-bold"> {{globalUserDataForm.get('selectedAmount').value |
                            number:'1.2-2'}}</span>
                    </div>

                    <!-- INPUT  WORKSHOPS -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedWorkshop').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_select}} {{translations.lbl_workshop}}</span>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <p-dropdown [disabled]="isOnlyArticles" [options]="workshops"
                                formControlName="selectedWorkshop" optionLabel="descrip" [showClear]="true"
                                placeholder="{{translations.lbl_select}}  {{translations.lbl_workshop}}"
                                (onChange)="onChangeUserPreferences()"></p-dropdown>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <button class="button-copy" type="button" pButton pRipple [icon]="getButtonConfig().icon"
                                [label]="getButtonConfig().label" [pTooltip]="getButtonConfig().tooltip"
                                [ngClass]="getButtonConfig().styleClass" (click)="toggleIsOnlyArticles()"
                                tooltipPosition="bottom" style="width: 100%;" [disabled]="isButtonClicked">
                            </button>
                        </div>
                    </div>

                    <!-- DATE TYPE -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedPrice').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_request_date}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-calendar formControlName="selectedDate" [touchUI]="true" [readonlyInput]="true"
                                inputId="touchui" dateFormat="yy-mm-dd"
                                [minDate]="globalUserDataForm.get('selectedMinDate1').value"
                                [maxDate]="globalUserDataForm.get('selectedMaxDate1').value"></p-calendar>

                        </div>
                    </div>

                    <!-- PACKAGE TYPE -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedPackage').value != null && globalUserDataForm.get('selectedWorkshop').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_number}} {{translations.lbl_of}}
                                {{translations.lbl_package}}s</span>
                        </div>
                        <div class="p-col-12 p-md-6">
                            <p-inputNumber inputId="withoutgrouping" formControlName="selectedPackage"
                                [minFractionDigits]="0" [maxFractionDigits]="0" mode="decimal" [min]="0"
                                [useGrouping]="false" [disabled]="isOnlyArticles"></p-inputNumber>
                        </div>
                        <div class="p-col-12 p-md-2">
                            <button class="button-copy"
                                [disabled]="(this.dataParent.status == 'R' || globalUserDataForm.get('selectedWorkshop').value == null || 
                            globalUserDataForm.get('selectedPackage').value == null ||
                            globalUserDataForm.get('selectedPackage').value <= 0 ) || isOnlyArticles == true  || blocked" type="button" pButton
                                pRipple icon="pi pi-check" (click)="createByPackages()" class="p-button-success"
                                pTooltip="{{translations.lbl_accept}}" tooltipPosition="bottom"
                                style="width: 100%;"></button>
                        </div>
                    </div>

                    <!-- AMOUNT TYPE
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedAmount').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_amount}} {{translations.lbl_material}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-inputNumber inputId="withoutgrouping" formControlName="selectedAmount"
                                [minFractionDigits]="2" [maxFractionDigits]="2" mode="decimal" [min]="0"
                                [useGrouping]="false"></p-inputNumber>
                        </div>
                    </div> -->
                </div>
            </p-panel>
        </div>
    </div>

    <p-tabView>
        <!-- TAB PANEL -->
        <p-tabPanel [header]="translations.lbl_list + ' ' + translations.lbl_of + ' ' + translations.lbl_items">

            <!-- MAIN TABLE -->
            <p-table #dt1 *ngIf="materials != null && globalUserPreferences?.storeId != null"
                [exportFilename]="tableName"
                [value]="globalUserDataForm.get('selectedDocumentsView').value ? materials : materialsTotal" [columns]="[
        { field: 'itemId', header: 'Articulo' },
        { field: 'descri', header: 'Nombre' },
        { field: 'matd.reqQty', header: 'Cantidad' },
        { field: 'price', header: 'Precio' },
        { field: 'amount', header: 'Importe' }]" [rows]="100" [rowsPerPageOptions]='["100","50","10"]'
                [globalFilterFields]="['itemId','descri','matd.reqQty','price','amount']" [paginator]="true"
                [rowHover]="true" dataKey="itemId"
                currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
                [showCurrentPageReport]="true" responsive="true" editMode="row">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                                class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button pButton pRipple icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadData()"
                                [pTooltip]="translations.lbl_reload + ' ' + translations.lbl_items"
                                tooltipPosition="bottom">
                            </button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="globalUserDataForm.get('selectedDocumentsView').value === false" colspan="6">
                            {{translations.lbl_description}}</th>
                        <th class="text-right" *ngIf="globalUserDataForm.get('selectedDocumentsView').value === false">
                            {{ translations.lbl_quantity }}</th>

                        <th class="text-right" *ngIf="globalUserDataForm.get('selectedDocumentsView').value === false">
                            {{ translations.lbl_amount}}</th>
                        <th class="text-right" *ngIf="globalUserDataForm.get('selectedDocumentsView').value === true">
                            {{translations.lbl_id}}{{translations.lbl_item}}</th>
                        <th *ngIf="globalUserDataForm.get('selectedDocumentsView').value === true" colspan="5">
                            {{translations.lbl_description}}</th>
                        <th class="text-right" *ngIf="globalUserDataForm.get('selectedDocumentsView').value === true">
                            {{ translations.lbl_quantity }}</th>
                        <th class="text-right" *ngIf="globalUserDataForm.get('selectedDocumentsView').value === true">
                            {{translations.lbl_unit_price}}</th>
                        <th class="text-right" *ngIf="globalUserDataForm.get('selectedDocumentsView').value === true">
                            {{ translations.lbl_amount }}</th>
                        <th class="text-right">
                            {{translations.lbl_edit}}</th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-itm let-editing="editing" let-ri="rowIndex">

                    <!-- HEADERS -->
                    <tr *ngIf="itm?.itemId == null">
                        <td class="itemCat2" colspan="6">
                            {{ itm?.descri ? itm.descri : 'S/N' }}
                        </td>
                    </tr>

                    <!-- NORMAL -->
                    <tr *ngIf="itm?.itemId != null" [pSelectableRow]="itm" [pEditableRow]="itm">

                        <!-- ID -->
                        <td class="text-right"> {{ itm?.itemId ?itm.itemId : 'S/N' }}</td>

                        <!-- DESCRIPTION -->
                        <td colspan="5" style="white-space: normal; word-wrap: break-word;">
                            <mark
                                [ngStyle]="{ 'background-color': itm?.itemColor != null ? itm?.itemColor : 'transparent' }">
                                {{ itm?.descri ? itm.descri : 'S/N' }}
                            </mark>
                        </td>

                        <!-- QUANTITY -->
                        <td class="text-right" *ngIf="itm?.matd?.reqQty != null && itm?.matd != null">
                            <p-cellEditor>

                                <ng-template pTemplate="input">
                                    <p-inputNumber inputId="withoutgrouping" [(ngModel)]="itm.matd.reqQty"
                                        mode="decimal" [min]="0" [useGrouping]="false"></p-inputNumber>
                                </ng-template>

                                <ng-template pTemplate="output">
                                    <span class="text-right">
                                        {{ itm?.matd?.reqQty ? (itm?.matd?.reqQty) :'0' }}
                                    </span>
                                </ng-template>

                            </p-cellEditor>
                        </td>

                        <!-- UNIT PRICE -->
                        <td *ngIf="globalUserDataForm.get('selectedDocumentsView').value === true" class="text-right">
                            {{
                            itm?.price ?(itm.price | number: '1.2-2') : '.00' }}
                        </td>

                        <!-- PRICE-->
                        <td *ngIf="globalUserDataForm.get('selectedDocumentsView').value === true"
                            style="text-align: right;">
                            <!-- Muestra el valor solo si itm.amount es mayor que 0 -->
                            <ng-container *ngIf="itm?.amount > 0; else showMark">
                                {{ itm.amount | number: '1.2-2' }}
                            </ng-container>

                            <!-- Muestra el <mark> cuando itm.amount es menor o igual a 0 -->
                            <!-- <ng-template #showMark>
                                <mark *ngIf="itm?.matd?.reqQty != null && itm?.matd?.reqQty > 0 && itm?.amount <= 0"
                                    [ngStyle]="{ 'background-color': 'red' }">
                                    {{ (translations.lbl_without + ' ' + translations.lbl_price) | uppercase }}
                                </mark>
                            </ng-template> -->
                        </td>

                        <td *ngIf="globalUserDataForm.get('selectedDocumentsView').value === false"
                            style="text-align: right;">
                            <!-- Muestra el valor solo si itm.amount es mayor que 0 -->
                            <ng-container *ngIf="itm?.amount > 0; else showMark">
                                {{ itm.amount | number: '1.2-2' }}
                            </ng-container>

                            <!-- Muestra el <mark> cuando itm.amount es menor o igual a 0
                            <ng-template #showMark>
                                <mark *ngIf="itm?.matd?.reqQty != null && itm?.matd?.reqQty > 0 && itm?.amount <= 0"
                                    [ngStyle]="{ 'background-color': 'red' }">
                                    {{ (translations.lbl_without + ' ' + translations.lbl_price) | uppercase }}
                                </mark>
                            </ng-template> -->
                        </td>

                        <!-- <td>
                            {{ "Edit: " + itm.canEdit}}
                        </td>
                        <td>
                            {{ "Inve: " + itm?.itm?.inventUpd}}
                        </td>
                        <td>
                            {{ "OnHa: " + itm.onHand}}
                        </td>
                        <td>
                            {{ "reQty: " + itm?.matd?.reqQty}}
                        </td> -->
                        <!-- BUTTONS Y MESSAGES -->
                        <td style="text-align:right">

                            <!-- BUTTONS -->
                            <ng-container *ngIf="itm.canEdit"> <!-- SI HAY INVENTARIO -->

                                <ng-container *ngIf="!editing"><!-- PENCIL -->
                                    <ng-container *ngIf="itm?.itm?.inventUpd === false || itm?.onHand > 0">
                                        <button pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                            pTooltip="{{ translations.lbl_edit }}" (click)="onRowEditInit(itm)"
                                            class="p-button-rounded p-button-text"
                                            [disabled]="dataParent.status === 'R' || editingRow !== null || (itm?.onHand <= 0 && itm?.itm?.inventUpd)">
                                        </button>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="editing">
                                    <button *ngIf="itm?.matd?.reqQty != null && itm?.matd != null" pButton pRipple
                                        type="button" pSaveEditableRow icon="pi pi-check"
                                        pTooltip="{{ translations.lbl_save }}" (click)="saveUpdatePriceItem(itm)"
                                        class="p-button-rounded p-button-text p-button-success p-mr-2"
                                        [disabled]="blocked"><!-- SAVE -->
                                    </button>

                                    <button pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                        (click)="onRowEditCancel(itm, ri)" pTooltip="{{ translations.lbl_back }}"
                                        class="p-button-rounded p-button-text p-button-danger"><!-- CANCEL -->
                                    </button>
                                </ng-container>
                            </ng-container>

                            <!-- MESSAGES -->
                            <span *ngIf="itm?.onHand <= 0 && itm?.itm?.inventUpd"
                                class="text-danger font-weight-bold d-block"> <!-- NO HAY INVENTARIO -->
                                {{ translations.lbl_out_of_stock }}
                            </span>

                            <span *ngIf="itm?.matd?.reqQty > 0 && itm?.amount <= 0 && !editing && !itm.canEdit"
                                class="text-danger font-weight-bold d-block"> <!-- NO HAY PRECIO -->
                                {{ capitalizeFirstLetter(translations.lbl_without) + ' ' + translations.lbl_price }}
                            </span>
                        </td>

                    </tr>

                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 9">
                            {{translations.lbl_no_records_found}}
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between"
                        *ngIf="this.globalUserDataForm.get('selectedDocumentsView').value == true">
                        {{translations.lbl_total}} {{materials != null ? materials.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between"
                        *ngIf="globalUserDataForm.get('selectedDocumentsView').value === false">
                        {{ translations.lbl_total }} 1 {{ translations.lbl_records }}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</div>

<!-- DIALOG CONFIRM -->
<p-dialog header="{{translations?.lbl_confirm}} {{translations?.lbl_approve}} {{translations?.lbl_inventory}}"
    [(visible)]="displayModalApprove" styleClass="p-fluid" [modal]="true" [style]="{width: '50vw'}" [maximizable]="true"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false" (onHide)="displayConfirmationViewCancel()">

    <!-- MAIN CONTENT -->
    <div class="p-grid" *ngIf="globalUserDataForm.get('selectedCoordination').value != null && 
                               globalUserDataForm.get('selectedGuide').value != null  && 
                               globalUserDataForm.get('selectedPeriod').value != null && 
                               globalUserDataForm.get('selectedDate').value != null && 
                               globalUserDataForm.get('selectedComponentType').value != null ">

        <!-- CORDINATION FORM -->
        <div class="p-col-12 p-md-12">
            <p-panel>
                <!-- COORDINATION FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

                    <!-- GUIDE  -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedGuide').value != null">
                        <span>{{translations.lbl_guide}}</span>
                        <span class="p-text-bold">{{this.globalUserDataForm.get("selectedGuide")?.value}}</span>
                    </div>

                    <!-- INPUT TYPE -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedComponentType').value != null">
                        <span>{{translations.lbl_type}}</span>
                        <span class="p-text-bold">{{this.globalUserDataForm.get("selectedComponentType")?.value}}</span>
                        <!-- <div class="p-col-12 p-md-6">
                            <input type="text" pInputText formControlName="selectedComponentType">
                        </div> -->
                    </div>

                    <!-- INPUT LIST -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedList').value != null">
                        <span>{{translations.lbl_current}} {{translations.lbl_price_list}}</span>
                        <span class="p-text-bold">{{this.globalUserDataForm.get("selectedList")?.value}}</span>
                    </div>

                    <!-- DATE TYPE -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedPrice').value != null">
                        <span>{{translations.lbl_delivery_date}}</span>
                        <span
                            class="p-text-bold">{{tovUtilsService.dateToTovpilDateFormat(globalUserDataForm.get("selectedDate")?.value)}}</span>
                        <!-- <div class="p-col-12 p-md-6">
                            <p-calendar formControlName="selectedDate" [touchUI]="true" [readonlyInput]="true"
                                inputId="touchui" dateFormat="yy-mm-dd"
                                [minDate]="globalUserDataForm.get('selectedMinDate1').value"
                                [maxDate]="globalUserDataForm.get('selectedMaxDate1').value"></p-calendar>

                        </div> -->
                    </div>

                    <!-- GAME PRICE TYPE -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedPrice').value != null && !isOnlyArticles">
                        <span>{{ capitalizeFirstLetter(translations.lbl_price)}} {{translations.lbl_package}}</span>
                        <span class="p-text-bold">{{this.globalUserDataForm.get("selectedPrice")?.value}}</span>
                        <!-- <div class="p-col-12 p-md-6">
                            <input type="text" pInputText formControlName="selectedPrice">
                        </div> -->
                    </div>

                    <!-- INPUT  WORKSHOPS -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedWorkshop').value != null">
                        <span>{{translations.lbl_select}} {{translations.lbl_workshop}}</span>
                        <span class="p-text-bold">{{this.globalUserDataForm.get("selectedWorkshop")?.value?.descrip}}
                        </span>
                        <!-- <div class="p-col-12 p-md-6">
                            <p-dropdown [options]="workshops" formControlName="selectedWorkshop" optionLabel="descrip"
                                [showClear]="true"
                                placeholder="{{translations.lbl_select}}  {{translations.lbl_workshop}}"
                                (onChange)="onChangeUserPreferences()"></p-dropdown>
                        </div> -->
                    </div>

                    <!-- Quantity -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedPackage').value != null  && !isOnlyArticles">
                        <span>{{translations.lbl_quantity}}</span>
                        <span class="p-text-bold">{{this.globalUserDataForm.get("quantityPackage")?.value}}</span>
                        <!-- <div class="p-col-12 p-md-6">
                         <p-inputNumber formControlName="quantityPackage"></p-inputNumber>

                     </div> -->
                    </div>

                    <!-- AMOUNT TYPE -->
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1"
                        *ngIf="globalUserDataForm.get('selectedAmount').value != null">
                        <span> {{translations.lbl_total}}</span>
                        <span class="p-text-bold">{{this.globalUserDataForm.get("selectedAmount")?.value | number: '1.2-2' }}</span>
                        <!-- <div class="p-col-12 p-md-6">
                         <input type="text" pInputText formControlName="selectedAmount">
                     </div> -->
                    </div>
                    <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1 warning-message"
                        *ngIf="globalUserDataForm.get('messageAudios')?.value != null">
                        {{globalUserDataForm.get('messageAudios')?.value }}
                    </div>
                </div>
            </p-panel>
        </div>
    </div>

    <!-- MAIN TABLE -->
    <p-table #dt1 *ngIf="materials != null && globalUserPreferences?.storeId != null" [exportFilename]="tableName"
        [value]="globalUserDataForm.get('selectedDocumentsView').value ? materials : materialsTotal" [columns]="[
                { field: 'itemId', header: 'Articulo' },
                { field: 'descri', header: 'Nombre' },
                { field: 'matd.reqQty', header: 'Cantidad' },
                { field: 'price', header: 'Precio' },
                { field: 'amount', header: ' Importe' }]" [rows]="100" [rowsPerPageOptions]='["100","50","10"]'
        [globalFilterFields]="['itemId','descri','matd.reqQty','price','amount']" [rowHover]="true"
        dataKey="itemId"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
        [showCurrentPageReport]="true" responsive="true" editMode="row">


        <!-- HEADER -->
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="itemId">{{translations.lbl_id}} {{translations.lbl_item}}<p-sortIcon
                        field="itemId"></p-sortIcon></th>
                <th colspan="5" pSortableColumn="descri">{{translations.lbl_description}}<p-sortIcon
                        field="descri"></p-sortIcon></th>
                <th style="text-align: center;" pSortableColumn="matd.reqQty">
                    {{ translations.lbl_quantity + ' ' + translations.lbl_items }}<p-sortIcon
                        field="matd.reqQty"></p-sortIcon></th>
                <th style="text-align: center;" pSortableColumn="price">
                    {{translations.lbl_price}}<p-sortIcon field="price"></p-sortIcon></th>
                <th style="text-align: center;" pSortableColumn="amount"> {{ translations.lbl_amount + ' ' +
                    translations.lbl_material }}
                    <p-sortIcon field="amount"></p-sortIcon>
                </th>
            </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-itm let-editing="editing" let-ri="rowIndex">

            <!-- HEADERS -->
            <tr *ngIf="itm?.itemId == null">
                <td class="itemCat2" colspan="6">
                    {{ itm?.descri ? itm.descri : 'S/N' }}
                </td>
            </tr>

            <!-- NORMAL -->
            <tr *ngIf="itm?.itemId != null" [pSelectableRow]="itm" [pEditableRow]="itm">

                <td> {{ itm?.itemId ?itm.itemId : 'S/N' }}</td>

                <td colspan="5" style="white-space: normal; word-wrap: break-word;">
                    <mark [ngStyle]="{ 'background-color': itm?.itemColor != null ? itm?.itemColor : 'transparent' }">
                        {{ itm?.descri ? itm.descri : 'S/N' }}
                    </mark>
                </td>

                <td *ngIf="itm?.matd?.reqQty != null && itm?.matd != null">
                    <p-cellEditor>

                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="itm.matd.reqQty">
                        </ng-template>

                        <ng-template pTemplate="output">
                            <span style="text-align: right;">
                                {{ itm?.matd?.reqQty ? (itm?.matd?.reqQty | number:'1.2-2') :'.00' }}
                            </span>
                        </ng-template>

                    </p-cellEditor>
                </td>

                <td style="text-align: right;"> {{ itm?.price ?(itm.price | number: '1.2-2') : '.00' }}</td>
                <td style="text-align: right;"> {{ itm?.amount ?(itm.amount | number: '1.2-2') :'.00'}}</td>
            </tr>

        </ng-template>

        <!-- EMPTY -->
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns ? columns.length : 9">
                    {{translations.lbl_no_records_found}}
                </td>
            </tr>
        </ng-template>

        <!-- SUMMARY -->
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{materials != null ? materials.length : 0 }} {{translations.lbl_records}}.
            </div>
        </ng-template>

    </p-table>

    <ng-template pTemplate="footer">

        <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="displayConfirmationViewCancel()"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_approve}}"
            class="p-button-raised p-button-success" (click)="aprove()" [disabled]="blocked"
            [ngStyle]="{'background-color': '#960018', 'border-color': '#960018', 'color': 'white'}"></button>
    </ng-template>
</p-dialog>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>